import './Nav.css';
import { useEffect, useState, useRef } from 'react';
import { Link ,useLocation} from 'react-router-dom';

export function Nav({ pages }) {
   // const [index, setIndex] = useState(0)
    const [expanded, setExpand] = useState(true);
    const [dimensions, setDimensions] = useState(false)
    const [top, _setTop] = useState(0)
    const [left, setLeft] = useState('7.4%')
    const [isMobile, setMobile] = useState(false)
    const [start, setStart] = useState(false)
    const location = useLocation();
    const index = location.state;
    const ref = useRef({})
    const lineRef = useRef(null)
    const linkRefs = useRef([])

    const routeIndex = pages.findIndex((page) => {
        const format = page.split(' ').join('-').toLowerCase().trim()
        return `/${format}` === location.pathname
    })
    const desktopIndex = Number.isInteger(index) && index >= 0 && index < pages.length
        ? index
        : Math.max(routeIndex, 0)

    function setLine() {
        if (!dimensions) { return }
        if (window.innerWidth > 860) {
            const activeLink = linkRefs.current[desktopIndex]
            const line = lineRef.current
            if (!activeLink || !line) { return }

            const linkBounds = activeLink.getBoundingClientRect()
            const lineBounds = line.getBoundingClientRect()
            const center = linkBounds.left + linkBounds.width / 2
            setLeft(`${center - lineBounds.left}px`)
            setTop(0)
            return
        }
        setTop(index+1)
        setLeft('7.4%')
    }
    function setTop(ii) {
        const h = dimensions.title.height;
        const h2 = dimensions.nav.height;
        const r = (ii === 0) ? h * 0.886 : h + (h2 / (pages.length + 1.5)) + ((h2 / pages.length) * (ii - 1))
        _setTop(r + 'px')

    }


    ///refresh
    useEffect(() => {

    }, [dimensions])

    function refresh() {
        const mob = (window.innerWidth <= 860)
        setMobile(mob)
        if (mob) {
            setExpand(true)
        }

        const title = ref.current.children[0]
        const navHeight = pages.length * 58

        setDimensions({
            title: {
                height: title.clientHeight
            },
            nav: {
                height: navHeight
            }
        })
        //setMobile
    }

    ///effects
    useEffect(() => {
        if (dimensions && !start && isMobile) {
            setStart(true)
            setTimeout(close, 500)
        }
    }, [dimensions])
    useEffect(setLine, [index, dimensions])

    useEffect(() => {
        window.addEventListener('resize', refresh)
        setTimeout(refresh, 200)
        return () => {
            window.removeEventListener('resize', refresh);
        };

    }, [])



    //////////////////////////////////////////////////////////////////////////////
    function toggle() {
        if (expanded) { close() } else { open() }
    }
    function close() {
        setExpand(false)
        setTop(0)

    }
 function open() {
    setExpand(true)
    setTop(index + 1)
}
    function getClass() {
        const navclass = (expanded) ? 'open' : 'closed';
        return 'nav-expanded ' + navclass
    }

    const role = isMobile ? "button" : "heading";
    const tabIndexValue = isMobile ? 0 : -1;
    return (
        <section className='nav-section' role="navigation" >
            <nav className={getClass()} ref={ref} style={{ cursor: (isMobile) ? 'pointer' : 'initial' }}>
                <div className="nav-head">
                    <h1 className="nav-title" >
                        <div role={role} tabIndex={tabIndexValue} onClick={(isMobile) ? toggle : () => { }}>Lisanne Bovée</div>
                    </h1>
                </div>
                <ul className="nav-container">
                    {pages.map((p, i) => {
                        const format = p.split(' ').join('-').toLowerCase().trim()
                        return (
                            <li key={format}>
                                <Link
                                    ref={(element) => { linkRefs.current[i] = element }}
                                    to={`/${format}`}
                                    className="active"
                                    state={i}>
                                    {p}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </nav>
            <div className="nav-line" style={{ "top": top }}>
                <div ref={lineRef} aria-expanded={(expanded)} tabIndex={tabIndexValue} role={isMobile ? "button" : undefined} style={{ cursor: (isMobile) ? 'pointer' : 'initial' }} onClick={(isMobile) ? toggle : () => { }}>
                    <div className="nav-point-container" style={{ "left": left }}>
                        <div className="nav-point">
                            <div /><div /><div /><div />
                        </div>
                        {isMobile && <div className={(expanded) ? 'arrow-icon open' : 'arrow-icon close'}>
                            <div />
                            <div />
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div className="spacer" />
        </section>
    )
}
